export default function toPrice(
  value: number,
  {
    language,
    currency,
    dynamicDecimals = false
  }: {
    language: string | undefined;
    currency: string;
    dynamicDecimals?: boolean;
  }
) {
  try {
    if (!language || !currency) {
      return "";
    }

    const hasDecimals = !dynamicDecimals || value % 1 !== 0;
    return value.toLocaleString(language.replace("_", "-"), {
      currency,
      style: "currency",
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0
    });
  } catch (error) {
    return "INVALID_CURRENCY";
  }
}
